// extracted by mini-css-extract-plugin
module.exports = {"chartAxisG":"WOd63pLk"};